<template>
<!-- 移动端 -->
<div class="mains-page">
  <div class="industry">
    <!-- | Series Products -->
  <p class="indestry-lif">{{res1}}</p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <!-- <p class="indus-chan">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}{{res3}}</p> -->
  <p class="indus-chan1">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
 <!-- <img class="kongpai" :src="require('../assets/2023logoImage/' +formattedSrc)"> -->
 <img class="kongpai" :src="require('@/assets/footprint/' +formattedSrc)">
 </div>
</template>
<script>
export default {
  props: {
    res1: {
      type: String,
      default: ''
    },
    res2: {
      type: String,
      default: ''
    },
    res3: {
      type: String,
      default: ''
    },
    res4: {
      type: String,
      default: ''
    },
    res5: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formattedSrc: '',
      isSmallScreen: false
    }
  },
  created () {
    this.formattedSrc = this.res5.slice(20)
  },
  mounted () {
    this.formattedSrc = this.res5.slice(20)
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>
<style scoped lang="scss">
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
  }
@media screen and (min-width: 1920px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 375px;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 16px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    width: 1155px;
    // height: 728px;
  }
}
@media screen and (max-width: 1440px) and (min-width:1000px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
  }
}
@media screen and (max-width: 1000px) and (min-width:768px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
    // height: 1568px;
    height: 100%;
  }
}
@media screen and (max-width:375px) {
    .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 32px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right:25px;
    .indus-chan{
      margin-top: 45px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 794px;
    // height: 1007px;
    // height: 945px;
    height: 100%;
  }
}
@media screen and (max-width:414px) and (min-width: 376px)  {
      .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 27px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 973px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-20px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        .yuan1{
          position: absolute;
          top: 698px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing1{
          margin-left:5px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        .yuan2{
          position: absolute;
          top: 808px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing2{
          margin-left:27px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:82px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        .yuan3{
          position: absolute;
          top: 918px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing3{
          margin-left:111px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 116px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        .yuan4{
          position: absolute;
          top: 1029px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing4{
          margin-left:182px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 39px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
@media screen and (max-width:767px) and (min-width: 415px)  {
  .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 32px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right:25px;
    .indus-chan{
      margin-top: 45px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 794px;
    // height: 1007px;
    // height: 945px;
    height: 100%;
  }
  .zhuyao{
    text-align: center;
    color: #6accce;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .hengpai1{
    margin-top:10px ;
    margin-left:-35px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng1{
      .heng-blue1{
        margin-left:-20px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num1{
          margin-right: 10px;
        }
        .yuan1{
          position: absolute;
          top: 698px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing1{
          margin-left:5px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks1{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai2{
    margin-top:10px ;
    margin-left:-48px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng2{
      .heng-blue2{
        margin-left:2px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num2{
          margin-right: 5px;
          // margin-left:10px ;
        }
        .yuan2{
          position: absolute;
          top: 808px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing2{
          margin-left:27px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks2{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 35px;
    }
  }
  .hengpai3{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng3{
      .heng-blue3{
        margin-left:82px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num3{
          margin-right: 5px;
          // margin-left:10px ;
        }
        .yuan3{
          position: absolute;
          top: 918px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing3{
          margin-left:111px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks3{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 116px;
    }
  }
  .hengpai4{
    margin-top:10px ;
    margin-left:-208px ;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-heng4{
      .heng-blue4{
        margin-left:157px ;
        margin-bottom: 10px ;
        color: #5086c2;
        font-weight: 700;
        .num4{
          margin-right: 5px;
          // margin-left:10px ;
        }
        .yuan4{
          position: absolute;
          top: 1029px;
          left: 13px;
          display: inline-block;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 1px solid #5086c2;
        }
      }
        .moqing4{
          margin-left:182px ;
          color: #6f6b6b;
          font-size: 12px;
        }
    }
    .parks4{
      width: 130px;
      height: 100px;
      position: relative;
      top: 0;
      left: 39px;
    }
  }
  .guanjian{
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
  }
}
</style>
